import { gql } from '@apollo/client';
import { ClientFragment } from '../fragments/ClientFragment';
/**
 * @const ClientQuery
 * @since 1.0.0
 */
export const ClientQuery = gql `
  query ClientQuery($input: ClientInput!) {
    client(input: $input) {
      ...ClientFragment
    }
  }

  ${ClientFragment}
`;
